import { autoCapitalize } from '@/utils/autoCapitalize'
import { ViewOrAttachFilesTypes } from './ViewOrAttachFiles.types'

class ViewOrAttachFilesMapper {
  toDomain(persistenceData): ViewOrAttachFilesTypes {
    return {
      attachmentId: persistenceData?.idAnexo,
      extension: persistenceData?.nomeExtensao,
      description: autoCapitalize(persistenceData?.legenda),
      size: persistenceData?.tamanho,
    }
  }
}

export default new ViewOrAttachFilesMapper()
